// createToast is not default export
import { createToast } from '@kiwicom/orbit-components/lib/Toast'; // eslint-disable-line
import { AlertCircle, Alert as WarningIcon, CheckCircle } from '@kiwicom/orbit-components/icons';
import type { TranslationType } from '@kiwicom/account-consts';

import { ToastType } from './const';

const getIcon = (type): JSX.Element | null => {
  switch (type) {
    case ToastType.SUCCESS:
      return <CheckCircle />;

    case ToastType.WARNING:
      return <WarningIcon />;

    case ToastType.CRITICAL:
      return <AlertCircle />;

    default:
      return null;
  }
};

export type ShowToastArgs = XOR<
  {
    translatedContent: TranslationType;
    type?: ToastType;
  },
  {
    translatedContent: TranslationType;
    icon?: JSX.Element;
  }
>;

export default function showToast(props: ShowToastArgs) {
  if ('type' in props) {
    const { translatedContent, type } = props;

    return createToast(translatedContent, {
      icon: getIcon(type),
    });
  }
  const { translatedContent, icon } = props;

  return createToast(translatedContent, {
    icon,
  });
}
